import React, { useEffect, useRef, useReducer } from 'react';
import Statistic from './Statistic';
import { formatCountdown } from './utils';
import { cloneElement } from '../_util/reactNode';
const REFRESH_INTERVAL = 1000 / 30;
function getTime(value) {
    return new Date(value).getTime();
}
function defaultFormatter(value) {
    return value;
}
const Countdown = (props) => {
    const { value, format, onFinish, formatter = defaultFormatter } = props;
    // 强制渲染界面
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const timeStamp = getTime(value);
    const countdownRef = useRef();
    const idRef = useRef();
    // 触发渲染界面，如果达到目标位置不执行
    countdownRef.current = () => {
        forceUpdate();
        if (timeStamp <= Date.now()) {
            clearInterval(Number(idRef.current));
            if (onFinish && timeStamp < Date.now()) {
                onFinish();
            }
        }
    };
    // 启动计时器
    useEffect(() => {
        if (timeStamp >= Date.now()) {
            if (!idRef.current) {
                idRef.current = setInterval(() => {
                    countdownRef.current();
                }, REFRESH_INTERVAL);
            }
        }
        else {
            clearInterval(Number(idRef.current));
        }
        return () => clearInterval(Number(idRef.current));
    }, [format, value]);
    // Countdown do not need display the timeStamp
    const valueRender = (node) => cloneElement(node, {
        title: undefined,
    });
    const countdownFormatter = (valueFormatter, config) => {
        const value = formatCountdown(valueFormatter, { ...config, format });
        if (typeof formatter === 'function') {
            return formatter(value);
        }
        return value;
    };
    return (React.createElement(Statistic, Object.assign({ valueRender: valueRender }, props, { formatter: countdownFormatter })));
};
Countdown.defaultProps = {
    format: 'HH:mm:ss',
};
export default Countdown;
